import { WatercraftLineSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/watercraft-line-svg/watercraft-line-svg.component';
import { RecLineSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/rec-line-svg/rec-line-svg.component';
import { UmbrellaLineSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/umbrella-line-svg/umbrella-line-svg.component';
import { BizLineSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/biz-line-svg/biz-line-svg.component';
import { MotorcycleLineSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/motorcycle-line-svg/motorcycle-line-svg.component';
import { HouseLineSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/house-line-svg/house-line-svg.component';
import { GenericInformationTemplateComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/generic-information-template/generic-information-template.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, GenericInformationTemplateComponent, HouseLineSvgComponent, MotorcycleLineSvgComponent, BizLineSvgComponent, UmbrellaLineSvgComponent, RecLineSvgComponent, WatercraftLineSvgComponent],
  selector: 'app-information-products',
  templateUrl: './information-products.component.html',
})
export class InformationProductsComponent  {
  
}
